import SideMenu from "../../../ui/SideMenu";
import React, { useState } from "react";
import BotNameSettings from "../../../shared/create-bot/settings-steps/BotNameSettings";
import SelectExchangeSettings from "../../../shared/create-bot/settings-steps/SelectExchangeSettings";
import styles from "../../../styles/Components/bot/create-bot/CreateBotMenu.module.css";
import { Button } from "antd";
import RiskPreferencesSettings from "../../../shared/create-bot/settings-steps/RiskPreferencesSettings";
import TargetReturnsSettings from "../../../shared/create-bot/settings-steps/TargetReturnsSettings";
import CryptoAllocationSettings from "../../../shared/create-bot/settings-steps/CryptoAllocationSettings";
import SignalSourceSettings from "../../../shared/create-bot/settings-steps/SignalSourceSettings";
import AIAssistantModeSettings from "../../../shared/create-bot/settings-steps/AIAssistantModeSettings";
import TradingStrategySettings from "../../../shared/create-bot/settings-steps/TradingStrategySettings";
import CoinNumbersSettings from "../../../shared/create-bot/settings-steps/CoinNumbersSettings";
import ConfigsReview from "../../../shared/create-bot/settings-steps/ConfigsReview";
import { createBot } from "../../../redux/bot/actions";
import { useDispatch, useSelector } from "react-redux";
import useUserData from "../../../hooks/useUserData";
import { closeSideMenu } from "../../../redux/ui/uiSlice";

function CreateBotMenu() {
  const {
    botState: { createBotLoading },
  } = useSelector((state) => state);

  const [step, setStep] = useState(1);
  const [botConfig, setBotConfig] = useState({
    bot_name: "CryptoCrispy bot1",
    selected_exchange: "cryptocrispy",
    trade_in_virtual_portfolio: "False",
    risk_tolerance: "3",
    target_return_percentage: "10",
    crypto_allocation_strategy: "balanced",
    signal_source: "AI_Assistant",
    ai_assistant_mode: "default",
    selected_trading_strategies: ["Time-based AI-assisted"],
    number_of_coins: "3",
  });

  const closeMenu = () => {
    setStep(1);
    setBotConfig({
      bot_name: "CryptoCrispy bot1",
      selected_exchange: "cryptocrispy",
      trade_in_virtual_portfolio: "False",
      risk_tolerance: "3",
      target_return_percentage: "10",
      crypto_allocation_strategy: "balanced",
      signal_source: "AI_Assistant",
      ai_assistant_mode: "default",
      selected_trading_strategies: ["Time-based AI-assisted"],
      number_of_coins: "3",
    });
  };

  const dispatch = useDispatch();
  const { username, email } = useUserData();

  const disabledNextStep =
    createBotLoading ||
    !botConfig?.bot_name ||
    botConfig?.selected_trading_strategies?.length === 0;

  const changeBotConfig = (key, value) => {
    if (key === "selected_trading_strategies") {
      let updatedStrategiesList;
      if (botConfig.selected_trading_strategies.includes(value)) {
        updatedStrategiesList = botConfig.selected_trading_strategies.filter(
          (item) => item !== value,
        );
      } else {
        updatedStrategiesList = [
          ...botConfig.selected_trading_strategies,
          value,
        ];
      }

      setBotConfig((prevState) => {
        return {
          ...prevState,
          [key]: updatedStrategiesList,
        };
      });
      return;
    }

    setBotConfig((prevState) => {
      return {
        ...prevState,
        [key]: value,
      };
    });
  };

  const skipHandler = () => setStep(5);

  const backHandler = () => {
    if (createBotLoading) return;

    setStep((prevState) => prevState - 1);
  };

  const nextHandler = async () => {
    if (step < 5) {
      setStep((prevStep) => prevStep + 1);
    } else {
      await dispatch(createBot(username, email, botConfig)).then(() => {
        dispatch(closeSideMenu());
        setStep(1);
        setBotConfig({
          bot_name: "CryptoCrispy bot1",
          selected_exchange: "cryptocrispy",
          trade_in_virtual_portfolio: "False",
          risk_tolerance: "3",
          target_return_percentage: "10",
          crypto_allocation_strategy: "balanced",
          signal_source: "AI_Assistant",
          ai_assistant_mode: "default",
          selected_trading_strategies: ["Time-based AI-assisted"],
          number_of_coins: "3",
        });
      });
    }
  };

  return (
    <SideMenu title="" scope="create-bot" closeHandler={closeMenu}>
      <div className={styles.container}>
        <h3 className={styles.title}>
          {step < 5 ? `Create Bot Manually (${step}/5)` : "Confirmation"}
          {step < 5 && (
            <span className={styles.directionBtn} onClick={skipHandler}>
              Skip
            </span>
          )}
        </h3>

        <div className={styles.stepContainer}>
          {step === 1 && (
            <>
              <BotNameSettings
                name={botConfig?.bot_name}
                changeConfig={changeBotConfig}
              />
              <SelectExchangeSettings
                selectedExchange={botConfig?.selected_exchange}
                changeConfig={changeBotConfig}
              />
            </>
          )}

          {step === 2 && (
            <>
              <RiskPreferencesSettings
                selectedRisk={botConfig?.risk_tolerance}
                changeConfig={changeBotConfig}
              />
              <TargetReturnsSettings
                changeConfig={changeBotConfig}
                targetReturns={botConfig?.target_return_percentage}
              />
            </>
          )}

          {step === 3 && (
            <>
              <CryptoAllocationSettings
                changeConfig={changeBotConfig}
                cryptoAllocation={botConfig?.crypto_allocation_strategy}
              />
              <SignalSourceSettings
                signalSource={botConfig?.signal_source}
                changeConfig={changeBotConfig}
              />
              {botConfig.signal_source === "AI_Assistant" && (
                <AIAssistantModeSettings
                  aiMode={botConfig?.ai_assistant_mode}
                  changeConfig={changeBotConfig}
                />
              )}
            </>
          )}

          {step === 4 && (
            <>
              <TradingStrategySettings
                tradingStrategy={botConfig?.selected_trading_strategies}
                changeConfig={changeBotConfig}
              />
              <CoinNumbersSettings
                coinNum={botConfig?.number_of_coins}
                changeConfig={changeBotConfig}
              />
            </>
          )}

          {step === 5 && (
            <ConfigsReview setStep={setStep} botConfig={botConfig} />
          )}
        </div>

        {/*<span onClick={() => setStep(1)}>Reset</span>*/}

        <div className={styles.buttons}>
          {step > 1 && !createBotLoading && (
            <span className={styles.directionBtn} onClick={backHandler}>
              Back
            </span>
          )}
          <Button
            className={styles.submitBtn}
            loading={createBotLoading}
            disabled={Boolean(disabledNextStep)}
            onClick={nextHandler}
          >
            {step < 5 ? "Next" : "Confirm"}
          </Button>
        </div>
      </div>
    </SideMenu>
  );
}

export default CreateBotMenu;
